import { useTranslation } from 'react-i18next';
import endImage from 'public/static/images/quickpicks/quickpicks-end.png';
import { screen } from 'components/styles/variables';
import css from 'styled-jsx/css';
import { LargeButton } from 'components/Shared/Buttons';
import styles from './styles';

interface EndCardProps {
  close: () => void;
}

const buttonCss = css.resolve`
.button
  flex-grow: 1;
  flex-basis: 0;
  height: 44px;
  font-size: 16px;
  padding: 9px 0px 11px 0px;
  width: 160px;
}
  @media (min-width: ${screen.smMin}) {
    .button {
    height: 56px;
    width: 192px;
    font-size: 18px;
    padding: 13px 0px 16px 0px;
    }
  }
`;

function EndCard({ close }: EndCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="end-card">
      <img className="end-image" src={endImage} alt="quickpicks-end" />
      <div className="title">{t('quickPicks.endCard.title')}</div>
      <div className="subtext">{t('quickPicks.endCard.subtext')}</div>
      <LargeButton
        onClick={(): void => {
          close();
        }}
        className={`button ${buttonCss.className}`}
      >
        {t('quickPicks.goBack')}
      </LargeButton>
      <style jsx>{styles}</style>
      {buttonCss.styles}
    </div>
  );
}

export default EndCard;
